/* -------------------------------------------------------------------------- */
/*                                Side menu styles                */
/* -------------------------------------------------------------------------- */

@import './bq-side-menu.variables';

:host {
  @apply flex overflow-hidden;
}

/* -------------------------------------------------------------------------- */
/*                               Aside container                              */
/* -------------------------------------------------------------------------- */

.bq-side-menu {
  @apply fixed flex h-dynamic-vh grow flex-col bg-[--bq-side-menu--bg-color] is-[--bq-side-menu--width] inset-bs-0 inset-is-0;
  @apply border-0 border-e-s border-solid border-[color:--bq-side-menu--border-color];
  @apply transition-[background-color,width] duration-150;
  @include hide-scrollbar;
}

.bq-side-menu.is-collapsed {
  @apply is-[--bq-side-menu--width-collapse];
}

/* -------------------------------------------------------------------------- */
/*                               Logo container                               */
/* -------------------------------------------------------------------------- */

.bq-side-menu--logo {
  @apply sticky top-0 z-[1] p-xs;
  @apply box-content flex items-center bg-[--bq-side-menu--bg-color] text-[color:--bq-side-menu--brand-color];
}

/* -------------------------------------------------------------------------- */
/*                                 APPEARANCE                                 */
/* -------------------------------------------------------------------------- */

/**
 * The following change the default values of some CSS custom properties
 * to make it complain with the side menu appearance selected
 */

:host([size='small']) {
  ::slotted(bq-side-menu-item) {
    --bq-side-menu-item--paddingY: theme(space.s);
  }
}

:host([appearance='brand']) {
  --bq-focus: theme(stroke.alt);
  --bq-side-menu--bg-color: theme(backgroundColor.ui.brand);
  --bq-side-menu--brand-color: theme(stroke.inverse);
  --bq-side-menu--border-color: theme(stroke.brand);

  ::slotted(bq-side-menu-item) {
    --bq-side-menu-item--bg-hover: color-mix(in srgb, var(--bq-ui--brand), var(--bq-hover) 20%);

    --bq-side-menu-item--text-default: theme(textColor.alt);
    --bq-side-menu-item--text-hover: theme(textColor.alt);
  }

  .bq-side-menu--footer ::slotted([slot='footer']) {
    --bq-ui--secondary: theme(colors.transparent);
    --bq-button--icon-color: theme(textColor.alt);
    --bq-button-hover--icon-color: theme(textColor.primary);
  }
}

:host([appearance='inverse']) {
  --bq-side-menu--bg-color: theme(backgroundColor.ui.inverse);
  --bq-side-menu--brand-color: theme(stroke.inverse);
  --bq-side-menu--border-color: theme(backgroundColor.ui.inverse);

  ::slotted(bq-side-menu-item) {
    --bq-side-menu-item--bg-hover: color-mix(in srgb, var(--bq-ui--inverse), var(--bq-hover) 20%);
    --bq-side-menu-item--bg-active: color-mix(in srgb, var(--bq-ui--alt), var(--bq-active) 20%);

    --bq-side-menu-item--text-default: theme(textColor.inverse);
    --bq-side-menu-item--text-hover: theme(textColor.inverse);
    --bq-side-menu-item--text-active: theme(textColor.primary);
  }

  .bq-side-menu--footer ::slotted([slot='footer']) {
    --bq-ui--secondary: theme(colors.transparent);
    --bq-button--icon-color: theme(textColor.inverse);
    --bq-button-hover--icon-color: theme(textColor.primary);
  }
}
